import {PB_SUPPORTED_FEATURES} from "@shared/platform/enums/supportedFeatures"

export const PB_FEATURES = [
  PB_SUPPORTED_FEATURES.MERCHANDISE,
  PB_SUPPORTED_FEATURES.GROUP_CELEBRATION,
  PB_SUPPORTED_FEATURES.POLL_RESULT_VISIBILITY,
  PB_SUPPORTED_FEATURES.EVERYONE_RECOGNITION
].join(",")
